import apiSlice from "../../app/api/apiSlice";

export const statisticsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCurrentUserStats: builder.query({
			query: () => `/api/user/stats`,
			providesTags: (result) => {
				return [{ type: "Stats", id: "LIST" }];
			},
		}),
		getCompanyGeneralStats: builder.query({
			query: ({ branch, range, weightFrom, weightTo }) =>
				`/api/company/stats/general?branch=${branch}&range=${encodeURIComponent(
					range
				)}&weightFrom=${weightFrom}&weightTo=${weightTo}`,
			providesTags: (result) => {
				return [{ type: "CompanyStats", id: "GENERAL_LIST" }];
			},
		}),
		getCompanyInTimeStats: builder.query({
			query: ({ branch, range, weightFrom, weightTo }) =>
				`/api/company/stats/inTime?branch=${branch}&range=${encodeURIComponent(
					range
				)}&weightFrom=${weightFrom}&weightTo=${weightTo}`,
			providesTags: (result) => {
				return [{ type: "CompanyStats", id: "IN_TIME_LIST" }];
			},
		}),
		getCompanyRelationStats: builder.query({
			query: ({ branch, range, weightFrom, weightTo }) =>
				`/api/company/stats/relation?branch=${branch}&range=${encodeURIComponent(
					range
				)}&weightFrom=${weightFrom}&weightTo=${weightTo}`,
			providesTags: (result) => {
				return [{ type: "CompanyStats", id: "RELATION_LIST" }];
			},
		}),
		// super admin
		getAdminStats: builder.query({
			query: ({ company, range, weightFrom, weightTo }) =>
				`/api/admin/stats/general?company=${company}&range=${encodeURIComponent(
					range
				)}&weightFrom=${weightFrom}&weightTo=${weightTo}`,
			providesTags: (result) => {
				return [{ type: "CompanyStats", id: "ADMIN_LIST" }];
			},
		}),
		getAdminWeeklyPublicationStats: builder.query({
			query: ({ country, company, range, page, perPage }) =>
				`/api/admin/stats/weeklyPublication?country=${country}&company=${company}&range=${encodeURIComponent(
					range
				)}&page=${page + 1}&perPage=${perPage}`,
			providesTags: (result) => {
				return [{ type: "CompanyWeeklyPublicationStats", id: "ADMIN_LIST" }];
			},
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetCurrentUserStatsQuery,
	useGetCompanyGeneralStatsQuery,
	useGetCompanyInTimeStatsQuery,
	useGetCompanyRelationStatsQuery,
	useGetAdminStatsQuery,
	useGetAdminWeeklyPublicationStatsQuery,
} = statisticsApiSlice;
